import { ToastNotifications } from '@lightspeed/design-system-react'
import { useT } from '@transifex/react'
import {
  useCustomerManager,
  useSaleManager,
} from '../../../../../../ng-compat/hooks'
import { useLineItemFulfillmentContext } from '../LineItemFulfillmentContext'
import {
  handleFulfillmentMethodViewNavigation,
  trimCustomerInfo,
} from '../LineItemFulfillmentUtils'
import { isDefinedFulfilmentType } from '../../../../../../models/fulfilment'
import { useAppSelector } from '../../../../../../state/hooks'
import { selectLineItem } from '../../../../../../state/slices/currentSale/currentSaleSlice'
import { selectOpenFulfilmentPopoverLineItemId } from '../../../../../../state/slices/uiStateSlice'

interface useLineItemFulfillmentCreateNewCustomerFlowProps {
  onClose: () => void
  saleHasServiceOrder?: boolean
}

export const useLineItemFulfillmentCreateNewCustomerFlow = ({
  onClose,
  saleHasServiceOrder = false,
}: useLineItemFulfillmentCreateNewCustomerFlowProps) => {
  const {
    setCurrentView,
    currentCustomer,
    setIsLoading,
    onSelectFulfilmentType,
  } = useLineItemFulfillmentContext()
  const t = useT()
  const saleManager = useSaleManager()
  const customerManager = useCustomerManager()
  const lineItemId = useAppSelector(selectOpenFulfilmentPopoverLineItemId)
  const lineItem = useAppSelector(selectLineItem(lineItemId))

  const handleContinueFromCreateNewCustomerView = async () => {
    if (currentCustomer) {
      try {
        trimCustomerInfo(currentCustomer)
        setIsLoading(true)
        const savedCustomer = await customerManager.saveNewCustomer(
          currentCustomer
        )
        await saleManager.addCustomer(savedCustomer)
        if (isDefinedFulfilmentType(lineItem?.fulfilmentType)) {
          onClose()
        } else {
          handleFulfillmentMethodViewNavigation(
            saleHasServiceOrder,
            onSelectFulfilmentType,
            onClose,
            setCurrentView
          )
        }
      } catch (_) {
        ToastNotifications.negative(t('Unable to create customer. Try again.'))
      } finally {
        setIsLoading(false)
      }
    }
  }

  return {
    handleContinueFromCreateNewCustomerView,
  }
}
